import { render, staticRenderFns } from "./userDetectionTimes.vue?vue&type=template&id=b87a6b64&scoped=true"
import script from "./userDetectionTimes.vue?vue&type=script&lang=ts"
export * from "./userDetectionTimes.vue?vue&type=script&lang=ts"
import style0 from "./userDetectionTimes.vue?vue&type=style&index=0&id=b87a6b64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87a6b64",
  null
  
)

export default component.exports